<div class="timepicker-container">
  <input
    type="time"
    [ngClass]="classes()"
    [disabled]="disabled()"
    [min]="min()"
    [max]="max()"
    [name]="name()"
    [id]="id()"
    [placeholder]="placeholder()"
    [ngModel]="time()"
    (ngModelChange)="time.set($event)"
    [ariaLabel]="'Choose Time'"
  />
</div>
